import React, { useEffect, useState, useContext } from "react";
import { fetchShippingMethode } from '../apis/apiBaltee.js';
import ShippingOptions from '../components/ShippingOptions.js';
import Loader from '../components/Loader.js';
// import { AuthContext } from "../contexts/AuthContext.js";
import { CartContext } from "../contexts/CartContext.js";
import { useNavigate } from "react-router-dom";
import { getCountryCode } from '../utils/all.js';
import '../styles/ShippingPage.css';

const ShippingPage = () => {
  const [shippingData, setShippingData] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [totalWeight, setTotalWeight] = useState(0); // État pour stocker le poids total
  // const authCtx = useContext(AuthContext);
  const { cartItems } = useContext(CartContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAddressAndShippingData = async () => {
      let shippingAddressData;

      shippingAddressData = JSON.parse(localStorage.getItem('shippingAddress'));

      // Si pas d'adresse de livraison, redirection
      if (!shippingAddressData) {
        navigate('/checkout/shipping-address');
        return;
      }

      setShippingAddress(shippingAddressData);

      try {
        // Calcul du poids total (en kg par ex.)
        // item.metadata.weight est une string, on fait parseFloat
        const totalWeightCalculated = cartItems.reduce((acc, item) => {
          // On récupère la valeur de weight depuis metadata (ou 0 si non défini)
          const itemWeight = parseFloat(item.metadata?.weight || "0");
          // On multiplie par la quantité (par défaut 1)
          return acc + (itemWeight * (item.quantity || 1));
        }, 0);

        setTotalWeight(totalWeightCalculated);

        // Conversion du pays en code iso2 si besoin (ex: 'FR', 'DE' etc.)
        const iso2CountryCode = await getCountryCode(shippingAddressData.country);

        // Appel API pour récupérer les méthodes d'expédition
        const shippingMethode = await fetchShippingMethode(
          iso2CountryCode,
          shippingAddressData.postal_code,
          totalWeightCalculated
        );

        const shippingMethodeWithDisplayName = addDisplayNameToShippingMethods(shippingMethode);
        setShippingData(shippingMethodeWithDisplayName);

      } catch (error) {
        console.error("Erreur lors de la récupération des méthodes d'expédition :", error);
      }
    };

    fetchAddressAndShippingData();
    // eslint-disable-next-line
  }, []); // Le tableau vide exécute l'effet une seule fois au montage

  function addDisplayNameToShippingMethods(methods) {
    return methods.map(method => {
      // Conversion en minuscule pour simplifier la détection de mots-clés
      const methodNameLower = method.name.toLowerCase();
      
      let display_name = '';
      
      if (methodNameLower.includes('service point')) {
        display_name = 'Point relais';
      } else if (methodNameLower.includes('home') && methodNameLower.includes('signature')) {
        display_name = 'Domicile avec signature';
      } else if (methodNameLower.includes('home')) {
        display_name = 'Domicile';
      } else {
        display_name = 'Indéfini'; 
        // Par exemple si vous souhaitez gérer d’autres cas 
        // ou laisser un texte par défaut
      }
      
      // Retourne une nouvelle copie de l'objet avec le champ display_name ajouté
      return {
        ...method,
        display_name
      };
    });
  }  

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
      {shippingData && shippingAddress ?
        <div>
          <div className="shipping-options-container">
          <h3>Options de livraison</h3>
          <p>
            Choisissez votre mode de livraison : à domicile pour plus de confort
            ou en point relais pour plus de flexibilité.
          </p>
          </div>

          {/* <p style={{textAlign: "center"}}>
            Poids total de la commande : <strong>{totalWeight.toFixed(2)} kg</strong>
          </p> */}

          <ShippingOptions
            shippingData={shippingData}
            shippingAddress={shippingAddress}
            totalWeight={totalWeight}
          />
        </div>
        :
        <Loader />
      }
    </div>
  );
};

export default ShippingPage;
